<template>
  <div>
    <div v-if="forceInvoice">
      You have invoicing enabled.
    </div>
    <div class="error" v-if="error" @click.stop="load">⚠️ Unable to load saved cards<div style="font-size: xx-small;">{{error}}</div></div>
    <template v-else-if="loaded">
      <div v-if="savedCards.length === 0">
        You have no saved cards.
      </div>
      <div v-else>
        <small>You own {{numOwned}} saved cards and have access to {{numShared}} team cards.</small>
      </div>
      <SavedCard :card="card" v-for="card in savedCards" :key="card.last4">
        <div class="card-buttons">
          <div v-if="card.available_to_team" v-b-tooltip.hover title="Team card"><i class="fas fa-users"/></div>
          <div v-else v-b-tooltip.hover title="Personal card"><i class="fas fa-user"/></div>
        </div>
      </SavedCard>
    </template>
    <WaveSpinner v-else-if="loading" />
  </div>
</template>

<style lang="scss" scoped>
.card-buttons {
  color: #aaa;
}
</style>


<script>
import {mapGetters, mapActions} from 'vuex';
import SavedCard from './billing/SavedCard.vue';
export default {
  components: {SavedCard},
  data() {
    return {loaded: false, loading: false, error: ''};
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters(['forceInvoice', 'savedCards', 'user']),
    numOwned() {
      return this.savedCards.filter(c => c.owner.id === this.user.id).length;
    },
    numShared() {
      return this.savedCards.length - this.numOwned;
    }
  },
  methods: {
    ...mapActions(['loadSavedCards']),
    async load() {
      if (this.forceInvoice) return;
      try {
        this.loading = true;
        this.loaded = false;
        this.error = '';
        await this.loadSavedCards();
        this.loading = false;
        this.loaded = true;
      } catch(e) {
        console.error(e);
        this.error = ''+e || 'Error';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/ViewBilling.vue